import { ScoredDrawResultComplete, UnscoredDrawResult } from '@API/game-results/types'
import { AnimationAddOnPanelProps } from './animation-add-on-panel'
import { AddOnHostConfig } from '@AppState/host-config'
import { TicketInfo } from '@Config/ticket-form-types'
import { store } from '@AppState/redux-store'
import { Utils } from '@Util/utils'

const mapUnscoredResultToProps = (
  result: UnscoredDrawResult,
  addOnConfigs: AddOnHostConfig[],
  display: boolean,
): AnimationAddOnPanelProps => {
  const hostConfig = store.getState().hostConfig.config

  const addOnComp: AnimationAddOnPanelProps = {
    display,
    multiplierAddOn: undefined,
    miniGameAddOn: undefined,
  }

  if (result.multiplierAddOnResult) {
    const valueString = Utils.getMultiplierDisplayValue(
      result.multiplierAddOnResult.value,
      hostConfig?.multiplierConfig.noMultiplierDisplayString,
    )

    addOnComp.multiplierAddOn = {
      name: result.multiplierAddOnResult.name,
      value: valueString,
      logoUrl: addOnConfigs.find((config) => config.name === result.multiplierAddOnResult?.name)
        ?.iconUrl,
    }
  }

  if (result.miniGameAddOnResult) {
    const addOnConfig = addOnConfigs.find(
      (addon) => addon.name === result.miniGameAddOnResult?.name,
    )

    addOnComp.miniGameAddOn = {
      name: result.miniGameAddOnResult.name,
      logoUrl: addOnConfig?.iconUrl ?? '',
      jackpotValue: result.jackpot,
      selections: [],
    }
  }
  return addOnComp
}

const mapCompletedTicketToProps = (
  ticketInfo: TicketInfo,
  result: ScoredDrawResultComplete,
  addOnConfigs: AddOnHostConfig[],
  animationDisplayNumberIndex: number,
  display: boolean,
) => {
  const props: AnimationAddOnPanelProps = {
    display,
    multiplierAddOn: undefined,
    miniGameAddOn: undefined,
  }
  const hostConfig = store.getState().hostConfig.config

  if (result.multiplierAddOnResult && ticketInfo.multiplierAddOnSelection) {
    props.multiplierAddOn = {
      name: result.multiplierAddOnResult.name,
      value: Utils.getMultiplierDisplayValue(result.multiplierAddOnResult.value, hostConfig?.multiplierConfig.noMultiplierDisplayString),
      logoUrl: addOnConfigs.find((config) => config.name === result.multiplierAddOnResult?.name)
        ?.iconUrl,
    }
  }

  if (result.miniGameAddOnResult && ticketInfo.miniGameAddOnSelection) {
    const addOnConfig = addOnConfigs.find(
      (addon) => addon.name === result.miniGameAddOnResult?.name,
    )
    const winningNumbers = result.winningNumbers

    props.miniGameAddOn = {
      name: result.miniGameAddOnResult.name,
      logoUrl: addOnConfig?.iconUrl ?? '',
      jackpotValue: result.jackpot,
      selections: ticketInfo.miniGameAddOnSelection.numberSelections.map((selection) => {
        const matchIndex = winningNumbers.findIndex(
          (num) => num.numberSelection === selection && !num.addonName,
        )
        return {
          number: selection,
          selected: matchIndex > -1 && matchIndex <= animationDisplayNumberIndex,
        }
      }),
    }
  }
  return props
}

export const AnimationAddOnPanelUtils = {
  mapUnscoredResultToProps,
  mapCompletedTicketToProps,
}
